/**
 * Auth bridge for the library app.
 *
 * The library and the main app share the same Better Auth session cookie —
 * no need to re-auth when crossing between / and /library. This file
 * exposes a small singleton `session` object that matches the slice of
 * main app's authState the library cares about (current user + admin flag).
 *
 * Intentionally does NOT import from ../../../src/client/auth.js. That module
 * pulls in the Better Auth client and inflates the bundle. Here we just hit
 * /api/auth/get-session ourselves (same endpoint, same cookie, same result)
 * and cache the response in our state store.
 */

import { state } from './state.js';
import { getSession } from './api.js';

/**
 * Hydrate `state.user` from the server. Call once on bootstrap.
 */
export async function loadSession() {
  const user = await getSession();
  state.set({ user });
  return user;
}

/**
 * Refresh the session. Callers can use this after sign-in/out events.
 * In Phase 1 we have no sign-in UI in the library itself, so this is
 * mostly for future use.
 */
export async function refreshSession() {
  return loadSession();
}
